<template>
  <div>Joining...</div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  consultantId?: string;
}>();
const user = useUserStore();
const router = useRouter();

onMounted(async () => {
  const query: Record<string, string> = {};
  if (props.consultantId) {
    query.consultant = props.consultantId;
  }
  router.push({ name: "opportunities-signup", query });
});
</script>

<style scoped></style>
